/**
 * HTTP header naming the client account (its Account Node ID) one request of a master account
 * session acts in, without switching the session.
 */
export const OFFICE_CLIENT_ACCOUNT_HEADER = 'x-insio-client-account';
